<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>光地搭建</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">光地搭建</div>
      </div>
    </div>

    <div style="padding:30px;min-height: 500px;min-width:1000px" class="wrap"> 
      <div class="box">
        <div class="title">司马</div>
        <div class="line">1.1、2.1、5.1、6.1、7.1馆国际/港澳台设备展区、1.1 馆国际/港澳台原料展区展商请在此报馆。</div>
        <div class="btn" @click="linkToRouter('https://bjservice.syma.com.cn/BakeryChina.aspx')">点击进入</div>
      </div>
      <div class="box">
        <div class="title">非得</div>
        <div class="line">7.1、8.1馆展商请在此报馆</div>
        <div class="btn" @click="linkToRouter('http://47.98.233.71/esm-fit/login')">点击进入</div>
      </div>
    </div>
  </div>
</template>

<script> 
export default {
  data () {
    return {
    };
  },
  computed: {
  },
  methods: {
    linkToRouter (url) {
      if (url.indexOf('http') !== -1 || url.indexOf('https') !== -1) {
        window.open(url);
      } else {
        this.$router.push(url);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.wrap {
  display: flex;
}
.box {
  width: 386px;
  height: 240px;
  background-color: #fff;
  margin-right: 100px;
  padding-top: 39px;
  text-align: center;
  display: inline-block;
  .title {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    margin-bottom: 29px;
  }
  .line {
    font-size: 14px;
    color: #333;
    padding: 0 20px;
    margin-bottom: 48px;
  }
  .btn {
    display: block;
    width: 112px;
    height: 32px;
    background-color: #4f65ae;
    border-radius: 4px;
    line-height: 32px;
    color: #fff;
    font-size: 14px;
    margin: 30px auto 0;
    cursor: pointer;
  }
}
</style>
